import { globals } from './globals';

const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

const formatWithDelimiters = (number, precision = 2, thousands = ',', decimal = '.') => {
  if (isNaN(number) || number == null) return 0;

  number = (number / 100.0).toFixed(precision);

  const [whole, fraction] = number.split('.');
  const formattedWhole = whole.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);

  return formattedWhole + (fraction ? decimal + fraction : '');
};

function formatMoney(cents) {
  if (typeof cents === 'string') cents = cents.replace('.', '');

  const formatString = globals.enableCurrency === true
    ? globals.moneyFormatWithCurrency
    : globals.moneyFormat;

  const placeholder = formatString?.match(placeholderRegex);

  // No placeholder (malformed/missing format): degrade to a plain delimited amount.
  if (!placeholder) return formatWithDelimiters(cents, 2);

  let value = '';

  switch (placeholder[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  value = formatString.replace(placeholderRegex, value);

  if (globals.enableZeros === false) {
    value = value.replace('.00', '');
  }

  return value;
}

const Shopify = window.Shopify ?? {};
Shopify.formatMoney = formatMoney;
export { Shopify };
